import { useSetAtom } from "jotai";
import { usePostHog } from "posthog-js/react";
import { MIGRATION_WIZARD_EVENTS } from "@/lib/posthog-constants";
import { migrationWizardOpenAtom } from "./migrationWizardState";

export type MigrationWizardOpenSource = "sidebar" | "home" | "empty_state";

export function useOpenMigrationWizard(source: MigrationWizardOpenSource) {
  const setOpen = useSetAtom(migrationWizardOpenAtom);
  const posthog = usePostHog();
  return () => {
    posthog?.capture(MIGRATION_WIZARD_EVENTS.OPEN, { source });
    setOpen(true);
  };
}
